export const getPathname = (): string => document.location.pathname;
